/**
 * @generated SignedSource<<21275a38e1138306fbc6478846e53fd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingAuditStartMutation$variables = {};
export type MeetingAuditStartMutation$data = {
  readonly startMeetingAudit: {
    readonly account: {
      readonly hasMeetingAuditLog: boolean;
    } | null;
  } | null;
};
export type MeetingAuditStartMutation = {
  response: MeetingAuditStartMutation$data;
  variables: MeetingAuditStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMeetingAuditLog",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingAuditStartMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StartMeetingAudit",
        "kind": "LinkedField",
        "name": "startMeetingAudit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingAuditStartMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StartMeetingAudit",
        "kind": "LinkedField",
        "name": "startMeetingAudit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "451a6819194d327b93c89ee6bca52f4a",
    "id": null,
    "metadata": {},
    "name": "MeetingAuditStartMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingAuditStartMutation {\n  startMeetingAudit {\n    account {\n      hasMeetingAuditLog\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a3d6c0cb0c15384b516881f21936b0b";

export default node;
